import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    checkChannel = new Subject();
    verificationChannel = new Subject();
    
    repository = new IndexRepository()

    constructor() {
        this.checkChannel.next({status: apiResponse.INITIAL})
        this.verificationChannel.next({status: apiResponse.INITIAL})
    }

    fetchCheck = async (query) => {
        try {
            this.checkChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheck(query).then((result) => {
                this.checkChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }

    fetchVerification = async (query) => {
        try {
            this.verificationChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchVerification(query).then((result) => {
                this.verificationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.verificationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }

    
}

export default IndexBloc